export default "__VITE_ASSET__HA$nqwcg__"